export default __webpack_public_path__ + "1c1350d483a85556dadcffc88917c86f.svg";